// extracted by mini-css-extract-plugin
module.exports = {"body":"ZHPRNTE4","fullscreenButtonContainer":"Lpvm292B","styledChartAreaWrapper":"M1z_T7uU","container":"yjtqZg1o","isChatMessage":"V6MDaxHg"};